const GET_SETTINGS = 'GET_SETTINGS';

const actionTypes = {
  GET_SETTINGS,
};

export default actionTypes;
